import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import { useAlert } from "../../context/AlertContext";
import { useLoading } from "../../context/LoadingContext";
import ConfirmModal from "../ConfirmModal";
import TableForm from "../TableForm";
import ItemStepMastersService from "../../services/itemstepmas.service";

const DataRecordingCommandForm = ({
  searchValue,
  editData,
  onSubmitCallback
}) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [itemStepMas, setItemStepMas] = useState([]);
  const defaultData = {
    Item_Step_Id: searchValue?.StepDes[0]?.value,
    Item_Record_Des: "",
    Record_Value: "",
    Record_UOM: "",
    Com_Code: user.Com_Code
  };
  const [data, setData] = useState({ Array: [defaultData] });
  const inputField = [
    { name: "Item_Record_Des", label: "รายละเอียดการบันทึก", type: "text" },
    { name: "Record_Value", label: "ค่า", type: "text", size: 2 },
    { name: "Record_UOM", label: "หน่วย", type: "text", size: 2 }
  ];

  const getItemStepMasters = () => {
    setLoading(true);
    ItemStepMastersService.getItemStepMasters(searchValue?.StepDes[0]?.value)
      .then((response) => setItemStepMas(response))
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    setData({
      Array: data.Array.map((item) => ({
        ...item,
        Record_Value: Number(item.Record_Value) || ""
      }))
    });

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    if (dataCallback) {
      if (!editData) onSubmitCallback(dataCallback);
      else onSubmitCallback(dataCallback.Array[0]);
    }
  };

  useEffect(() => {
    if (searchValue?.StepDes[0]?.value) getItemStepMasters();

    if (editData) {
      setData({
        Array: [
          {
            Item_Step_Id: editData.Item_Step_Id,
            Item_Record_Des: editData.Item_Record_Des,
            Record_Value: editData.Record_Value,
            Record_UOM: editData.Record_UOM,
            Com_Code: user.Com_Code
          }
        ]
      });
    }
  }, [editData]);

  return (
    <>
      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Body as={Row} className="justify-content-center">
          {[
            { name: "Item_Code", label: "รหัสสินค้า" },
            { name: "Item_Name_TH", label: "ชื่อสินค้า" }
          ].map(({ name, label }) => (
            <Col key={name} sm={3}>
              <FloatingLabel label={label} controlId={name}>
                <Form.Control
                  readOnly
                  type="text"
                  className="p-3"
                  name={name}
                  value={itemStepMas?.Item?.[name] || ""}
                />
              </FloatingLabel>
            </Col>
          ))}
        </Card.Body>
      </Card>

      <Form noValidate validated={validated} onSubmit={handleValidated}>
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Body>
            <TableForm
              data={data.Array}
              columns={inputField}
              editForm={!!editData}
              onChangeCallback={(newData) => setData({ Array: newData })}
              defaultData={defaultData}
            />
          </Card.Body>

          <Card.Footer className="p-3 text-end border-top-0 bg-transparent">
            <Button
              type="submit"
              variant="success"
              className="px-5 py-2 text-dark rounded-pill"
            >
              {editData ? "บันทึกการแก้ไข" : "บันทึกข้อมูล"}
            </Button>
            <ConfirmModal
              show={showModal}
              data={data}
              content={editData ? "edit" : "save"}
              onSubmitCallback={handleSubmit}
            />

            <Button
              variant="outline-success"
              className="px-5 py-2 text-dark border-secondary rounded-pill"
              onClick={() =>
                navigate("/wo_master/request", { state: searchValue })
              }
            >
              ยกเลิก
            </Button>
          </Card.Footer>
        </Card>
      </Form>
    </>
  );
};

DataRecordingCommandForm.propTypes = {
  searchValue: PropTypes.object.isRequired,
  editData: PropTypes.object,
  onSubmitCallback: PropTypes.func
};

export default DataRecordingCommandForm;
